<template>
  <div class="account tableStyle">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item label="类型：" class="screen">
              <el-select v-model="queryForm.type" placeholder="请选择类型" @change="handleSelectCompany(queryForm.type,'query')">
                <el-option label="厂商" :value="1"></el-option>
                <el-option label="物业" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="所属厂商/物业：" class="screen">
            <el-select v-model="queryForm.cid" placeholder="请选择" @change="getAllStation" @click.native="!queryForm.type?$message.error('请先选择类型'):''" :disabled="!queryForm.type" filterable>
              <el-option v-for="(item, index) in allManufacturerSearch" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="桩群：" class="screen">
            <el-select v-model="queryForm.pile_group_id"
              placeholder="请选择"
              :disabled="queryForm.cid === ''"
              @change="getTableList('query')"
              @click.native="judgeManufacturer">
              <el-option v-for="(item, index) in allStation" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态：" class="screen">
            <el-select v-model="queryForm.status" placeholder="请选择" @change="getTableList('query')">
              <el-option label="取消" :value="0"></el-option>
              <el-option label="生成" :value="1"></el-option>
              <el-option label="套餐未结束" :value="2"></el-option>
              <el-option label="退款受理中" :value="3"></el-option>
              <el-option label="商户异议" :value="10"></el-option>
              <el-option label="可提现" :value="100"></el-option>
            </el-select>
          </el-form-item>          

          <el-form-item label="日期：" class="screen">
            <el-date-picker
              v-model="queryForm.start_date"
              value-format="yyyy-MM-dd"
              type="date"
              @change="getTableList('query')"
              placeholder="选择日期">
            </el-date-picker>
            至
            <el-date-picker
              v-model="queryForm.end_date"
              value-format="yyyy-MM-dd"
              type="date"
              @change="getTableList('query')"
              placeholder="选择日期">
            </el-date-picker>            
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getTableList('query')">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- <el-row>
      <el-col :span="24">
        <el-button type="primary" size="small" @click="openDialog">新建分账参数</el-button>
      </el-col>
    </el-row> -->

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>        
        <el-table-column prop="company_name" label="厂商/物业名称" align="center"></el-table-column>
        <el-table-column prop="company_type_txt" label="类型" align="center"></el-table-column>        
        <el-table-column prop="company_mobile" label="厂商/物业联系电话" align="center" width="200"></el-table-column>
        <el-table-column prop="trig_time" label="分账时间" align="center" width="200"></el-table-column>
        <el-table-column prop="recon_from" label="分账来源" align="center"></el-table-column>
        <el-table-column prop="fz_all" label="收益说明" align="center"></el-table-column>
        <el-table-column prop="fz_lv" label="收益配置" align="center"></el-table-column>
        <el-table-column prop="fz_fee" label="收益金额" align="center"></el-table-column>
        <el-table-column prop="is_pay_str" label="提现状态" align="center"></el-table-column>
        <el-table-column prop="status_str" label="对账状态" align="center"></el-table-column>
        <el-table-column prop="pile_group_name" label="桩群名称" align="center"></el-table-column>
        <el-table-column prop="pile_code" label="电桩编码" align="center"></el-table-column>
        <el-table-column prop="fee_type" label="结算方式" align="center"></el-table-column>
        <!-- <el-table-column prop="fee" label="结算单价" align="center"></el-table-column> -->
        <el-table-column prop="note" label="备注" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pageFoot flex">
      <div class="tongji">
        <!-- 统计：共{{total}}个   -->
         总分账金额：{{statistics.all_money}}&nbsp;
         收益分账金额：{{statistics.all_money_cash}}&nbsp;
         电量收益分账： {{statistics.all_money_power}}<br>
         已经提现： {{statistics.has_pay_money.payed_money}}&nbsp;
         提现中：{{statistics.has_pay_money.paying_money}}&nbsp;
         总提现金额：{{statistics.has_pay_money.pay_money}}&nbsp;
         可提现金额：{{statistics.hasnt_pay_money.can_pay_money}}&nbsp;
         不可提现金额：{{statistics.hasnt_pay_money.cant_pay_money}}&nbsp;
         未提现总金额：{{statistics.hasnt_pay_money.pay_money}}
      </div>




      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="queryForm.size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>


        <!-- 订单详情弹窗 -->
        <el-dialog title="订单详情" width="35%" top="5vh" custom-class="dialogBox" :visible.sync="dialogVisible" @close="closeDialog">
            <div class="detail">
                <div class="detail-item">
                    <!-- <div class="detail-title">订单详情</div> -->
                    <div class="detail-content">
                        <el-row>
                            <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
                                <div class="datas">
                                    <div class="left">
                                      <div class="label" v-for="(item,index) in detail.order_datas.columns" :key="index">{{item}}：</div>
                                    </div>
                                    <div class="right">
                                      <div class="value" v-for="(item,index) in detail.order_datas.data" :key="index+'d'">{{ item }}</div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <div class="detail_item_footer">
              <el-button type="primary" size="medium" @click="dialogVisible = false">关闭</el-button>
            </div>               
        </el-dialog>
    


    
  </div>
</template>
<script>
export default {
  data() {
    return {
      size: 20,
      page: 1,
      total: 0,
      statistics:{
        has_pay_money:{},
        hasnt_pay_money:{}
      }, //统计
      queryForm:{
        page: 1,
        size: 20,
        type:null, //1厂商 2物业
        cid: '',
        pile_group_id: '',
        status:'',
        start_date:'',
        end_date:'',

      },

      detail:{
        order_datas:{
          columns:{},
          data:{},
        },

      },  //详情

      tableData: [],
      dialogVisible: false,
      addForm:{
        cid: '',
        pile_group_id: [],  //桩群单个改为多个
        fee: '',
        note: '',
        fee_type: 0,  //结算方式
        fee_company:1, //物业结算比例
      },
      // rules: {
      //   company_type:[{required: true, message: "请选择类型", trigger: 'change'}],
      //   cid: [
      //       { required: true, message: "请选择所属厂商/物业", trigger: 'change'}
      //   ],
      //   fee: [
      //     {required: true, message: '请输入结算单价', trigger: 'blur'},
      //   ],        
      //   fee_company:[
      //     {required: true, message: '请输入结算比例', trigger: 'blur'},
      //   ],
      //   pile_group_id:[
      //     {required: true, message: '请选择桩群', trigger: 'change',type:'array'},
      //   ]
      // },
      allManufacturerSearch:[], //搜索
      allManufacturer: [],
      allStation: [],
      addStations: []
    };
  },
  created() {
    
    this.init();

  },
  methods: {
    // 初始化
    init() {
        this.getTableList();
        // this.getAllManufacturer(); //所有厂商物业列表
    },
    // 获取table
    getTableList(type){
      if(type === 'query'){
        this.queryForm.page = 1;
      }
      let params = {
        page: this.queryForm.page,
        size: this.queryForm.size,
        query_columns: {            
          cid: this.queryForm.cid,  //物业、商家id
          pg_id: this.queryForm.pile_group_id,  //桩群id
          p_id:'',  //桩id
          status:this.queryForm.status,  //分账状态 
          day:'',   // 查询某一天
          start_date:this.queryForm.start_date,
          end_date:this.queryForm.end_date,
        }
      };

      let url = this.$route.query.id ? 'getReconciliationsByCash' : 'getReconciliations';  //有id请求提现详情id传来的分账列表，无则分账列表

      //接收从提现列表详情id
      if(this.$route.query.id){
        params.id = this.$route.query.id;
      }


      this.$api[url](params).then(res=>{
          if (res.code === 200) {
              this.total = res.data.count;
              this.tableData = res.data.list;
              this.statistics = res.data.statistics;
          } else {
            return this.$message.error(res.msg);
          }
      });
    },


    //选择物业厂商
    handleSelectCompany(type,str){
      if(str==='query'){        
        this.queryForm.cid = ''; 
        this.allManufacturerSearch = [];
      }
     
      if(str==='dialog'){
        this.addForm.cid = '';
        this.allManufacturer = [];
      }
      
      
      this.getAllManufacturer(type,str);
    },


    // 获取所有厂商列表
    getAllManufacturer(type,str){
      let params = {
        type: type  //类型 1厂商 2物业
      }
      this.$http.get(this.common.admin+'/admin/companyAllList',{params}).then(res => {
        if(res.code === 200){
          if(str==='query'){
            this.allManufacturerSearch = res.data;
          }
          if(str==='dialog'){
            this.allManufacturer = res.data;
          }
          
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // 获取所有桩群
    getAllStation(val, type){
      let params = {
        cid: val,
        page: 1,
        size: 10000,
        created: 0  //0全部，1未配置的 //需求变更为不管有没有配置过都可选
        // created: type === 'add' ? 1 : 0  //0全部，1未配置的  
      };
      this.$http.post(this.common.admin + '/api/getGroupList',params).then(res => {
        if(res.code === 200){
          if(type === 'add'){
            // this.addStations = [{id: 0, name: '全部'}, ...res.data.list];
            this.addStations = [...res.data.list]; //去掉全部桩群
          }else if(type === 'edit'){
            this.addStations = res.data.list;
          }else{
            this.allStation = res.data.list;
          }
        }else{
          return this.$message.error(res.msg);
        }
      });
    },
    judgeManufacturer(){
      if(this.queryForm.cid === ''){
        return this.$message.error('请先选择所属厂商/物业');
      }
    },
    // 重置查询条件
    resetQuery() {
      this.queryForm = {
        page: 1,
        size: 20,
        type:null, //1厂商 2物业
        cid: '',
        pile_group_id: '',
        status:'',
        start_date:'',
        end_date:'',
      };      
      this.getTableList();
    },
    // 打开新建弹窗
    openDialog(){
      this.dialogVisible = true;
    },
    // 关闭新建弹窗
    closeDialog(){
      this.dialogVisible = false;
      this.addForm = {
        company_type:'', //company
        cid: '',
        fee: '',
        note: ''
      };
      this.allManufacturer = [];  //company
      // this.$nextTick(() => {
      //   this.$refs.addForm.clearValidate();
      // });
    },
    // 弹窗获取桩群
    goGetStatios(val, type){
      this.getAllStation(val, type ? type : 'add');
    },

    // 翻页
    changePage(page) {
      // this.page = page;
      this.queryForm.page = page;
      this.getTableList();
    },
    sizeChange(val){
      // this.size = val;
      this.queryForm.size = val;
      this.getTableList();
    },

    //查看详情
    goDetail(row){
      this.detail = row;
      // this.detail.orderDataList = [];
      // for(keyName in row.order_datas.columns){
      //   console.log(keyName)
      // }

      // for(keyValue in row.order_datas.data){
      //   console.log(keyValue);
      // }
      
      console.log(row)
      this.openDialog();
    },




  },
};
</script>
<style lang="less" scoped>
.account{
  height: 100%;
  display: flex;
  flex-direction: column;

  .tableArea{
    flex: 1;
    min-height: calc(100% - 167px);
  }
  .pageFoot{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tongji{
      font-size: 14px;
    }
  }
}


.datas{display: flex;width: 100%;
  .left{width: 100px;text-align: right;
    > div{height:50px;line-height: 50px;font-weight: bold;}
  }
  .right{
    > div{height:50px;line-height: 50px;}
  }
}

.detail_item_footer{text-align: center;}
</style>